import { message } from 'antd'
import moment from 'moment'

import { Production } from '../production.schema'

export const ProductionFormInputMaxCount = 10000 as const

export const getProductionFormValues = (production: Production) => {
  const additions = production.additions || []

  const stageTarget = additions
    .filter((a) => a.type === 'Stage')
    .map((a) => {
      let stageValue
      try {
        stageValue = JSON.parse(a.value)
      } catch {
        stageValue = {
          value: a.value,
        }
      }
      return {
        date: moment(a.subType),
        value: stageValue.value,
        standard: stageValue.standard,
        content: stageValue.content,
        predictWorkload: stageValue.predictWorkload,
      }
    })

  const data = {
    name: production.name,
    email: production.email,
    range: [
      production.startDate ? moment(production.startDate) : null,
      production.endDate ? moment(production.endDate) : null,
    ],
    projectType: production.projectType,
    expectDeliveryTime: production.expectDeliveryTime ? moment(production.expectDeliveryTime) : undefined,
    classification: production.classification,
    priority: production.priority,
    standard: production.standard,

    background: production.background, // 已转化为 动机
    requirement: production.requirement,
    stage: production.stage,
    situationDescription: production.situationDescription,
    competition: production.competition,

    businessResult: production.businessResult,
    userAcceptance: production.userAcceptance,
    productQuality: production.productQuality,
    marketIndicators: production.marketIndicators,
    stageTarget,

    expectProductionTime: production.expectProductionTime ? moment(production.expectProductionTime) : undefined,
    expectTargetCheckTime: production.expectTargetCheckTime ? moment(production.expectTargetCheckTime) : undefined,
  }

  return data
}

export type ProductionFromValues = {
  cycleId: number
  departmentId: number
  email: string
  name: string
  range: [string, string]
  requirementTypes: string
}

export const onProductionFormFinish = (form: any, t: any, onSubmit: (data: any) => Promise<Production>) => async () => {
  const DateFormat = 'YYYY-MM-DD hh:mm:ss'

  const values = await form.validateFields()
  // 用于在分区编辑时 获取 form 表单所有字段
  const data = { ...form.getFieldsValue(true), ...values }

  // eslint-disable-next-line no-console
  const { range, ...fields } = data

  // 检查 stageTarget
  const stageTarget = []
  if (fields.stageTarget) {
    for (let i = 0; i < fields.stageTarget.length; i++) {
      const { date, value, standard, content, predictWorkload } = fields.stageTarget[i]
      if (!value || !date || !standard || !content) {
        message.error(`${t('production.form.stageTarget.title')}${i + 1} 缺少必填项`)
        return
      }
      stageTarget[i] = {
        name: date.format('YYYY-MM-DD'),
        value: JSON.stringify({ value, standard, content, predictWorkload: predictWorkload || 0 }),
        field: `Stage.${i}`,
      }
    }
  }

  const submitData = {
    ...fields,
    expectDeliveryTime: fields.expectDeliveryTime.utc().format(DateFormat),
    startDate: range ? range[0].utc().format(DateFormat) : undefined,
    endDate: range ? range[1].utc().format(DateFormat) : undefined,
    expectProductionTime: fields.expectProductionTime
      ? fields.expectProductionTime.utc().format(DateFormat)
      : undefined,
    expectTargetCheckTime: fields.expectTargetCheckTime
      ? fields.expectTargetCheckTime.utc().format(DateFormat)
      : undefined,
    stageTarget,
  }

  return onSubmit(submitData)
}
